export const AEGON = 3;
export const ALFAFB = 1003;
export const ALLIANZ = 1;
export const CIGPAN = 26;
export const CIGPANFB = 1026;
export const COLONNADE = 38;
export const DAS = 28;
export const GENERALI = 2;
export const GENERTEL = 13;
export const GROUPAMA = 8;
export const KHB = 10;
export const KOBE = 15;
export const MAPFRE = 21;
export const EUROP = 41;
export const MKB = 14;
export const OMINIMO = 39;
export const POSTA = 9;
export const SIGNAL = 4;
export const UNION = 11;
export const UNIQA = 6;
export const UNIQAFB = 1006;
export const WABERER = 16;
export const EUB = 29;

export const MINDEN_BIZTOSITO = [
    AEGON,
    ALFAFB,
    ALLIANZ,
    CIGPAN,
    CIGPANFB,
    DAS,
    EUROP,
    GENERALI,
    GENERTEL,
    GROUPAMA,
    KHB,
    KOBE,
    MAPFRE,
    MKB,
    OMINIMO,
    POSTA,
    SIGNAL,
    UNION,
    UNIQA,
    WABERER,
];

export const BIZT_NAMES = {
    [AEGON]: 'alfa',
    [ALFAFB]: 'alfafb',
    [EUROP]: 'europ',
    [ALLIANZ]: 'allianz',
    [CIGPAN]: 'cig',
    [CIGPANFB]: 'cig',
    [DAS]: 'das',
    [GENERALI]: 'generali',
    [GENERTEL]: 'genertel',
    [GROUPAMA]: 'groupama',
    [KHB]: 'khb',
    [KOBE]: 'kobe',
    [MAPFRE]: 'mapfre',
    [MKB]: 'mkb',
    [OMINIMO]: 'ominimo',
    [POSTA]: 'posta',
    [SIGNAL]: 'signal',
    [UNION]: 'union',
    [UNIQA]: 'uniqa',
    [UNIQAFB]: 'uniqafb',
    [WABERER]: 'gránit',
};

export function getBiztNameById(biztositoid) {
    return MINDEN_BIZTOSITO.includes(biztositoid) ? BIZT_NAMES[biztositoid] : '';
}
